import styled from 'styled-components';
import {
  Skeleton,
} from 'antd';

export const StyledAntdSkeleton = styled(Skeleton)`
`;
